import React, { useState, useEffect } from 'react'; 
import { FaHistory } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const symbols = ["ethusdt", "btcusdt"];

const BinanceSpread = () => {
  const navigate = useNavigate(); 
  const [prices, setPrices] = useState({});
  const [total, setTotal] = useState(null);
  const [quantity, setQuantity] = useState();
  const [orderQuantity, setOrderQuantity] = useState("");
  const [entryPrice, setEntryPrice] = useState("");
  const [targetPrice, setTargetPrice] = useState("");
  const [leverageValue, setLeverageValue] = useState(1);
  // const [orderHistory, setOrderHistory] = useState([]);


  const [openPosition, setOpenPosition] = useState(null);
  const [openOrders, setOpenOrders] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const BaseUrl = process.env.REACT_APP_API

  const handleLogout = () => {
    sessionStorage.removeItem("binance-token");
    toast.success("Logged out successfully");
    navigate("/Login");
  };
  

  const symbol = "ETHUSDT";
  const fetchOpenPosition = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/open-position?symbol=${symbol}`);
      const data = await response.json();
      const sortedOrderHistory = data.orderHistory.sort((a, b) => b.time - a.time);
      setOpenPosition(data.openPosition);
      setOpenOrders(data.openOrders);
      setOrderHistory(sortedOrderHistory);
    } catch (error) {
      console.error("Failed to fetch open position:", error);
    }
  };
  
  // useEffect(() => {
  //   fetchOpenPosition();
  // }, []);
  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchOpenPosition();
    }, 5000); // Run every 5 seconds
  
    // Call it immediately as well
    fetchOpenPosition();
  
    // Cleanup function to clear the interval
    return () => clearInterval(intervalId);
  }, []);
  

  const fetchOrderHistory = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/orders/history`);
      const data = await response.json();
      if (data.success) {
        setOrderHistory(data.orders);
      }
    } catch (error) {
      console.error("Failed to fetch order history:", error);
    }
  };

  useEffect(() => {
    fetchOrderHistory();
  }, []);


  useEffect(() => {
    const ws = new WebSocket(
      `wss://fstream.binance.com/stream?streams=${symbols
        .map((s) => `${s}@ticker`)
        .join("/")}`
    );

    ws.onmessage = (event) => {
      const message = JSON.parse(event.data);
      const data = message.data;
      if (!data || !data.s || !data.c) return;

      setPrices((prev) => {
        const updatedPrices = { ...prev, [data.s]: parseFloat(data.c) };

        const ethPrice = updatedPrices.ETHUSDT;
        const btcPrice = updatedPrices.BTCUSDT;

        if (ethPrice && btcPrice) {
          const calculatedTotal = (ethPrice * quantity) - btcPrice;
          setTotal(calculatedTotal.toFixed(4));
        }

        return updatedPrices;
      });
    };

    return () => ws.close();
  }, [quantity]);

  const handlePlaceOrder = async () => {
    if (
      !symbol ||
      !orderQuantity ||
      isNaN(orderQuantity) ||
      parseFloat(orderQuantity) <= 0 ||
      !entryPrice ||
      isNaN(entryPrice) ||
      parseFloat(entryPrice) <= 0 ||
      !targetPrice ||
      isNaN(targetPrice) ||
      parseFloat(targetPrice) <= 0 ||
      !leverageValue ||
      isNaN(leverageValue) ||
      parseInt(leverageValue, 10) <= 0
    ) {
      toast.error("Please fill out all fields.");
      return;
    }
    try {
      const payload = {
        symbol,
        side: 'BUY',
        quantity: parseFloat(orderQuantity),
        entryPrice: parseFloat(entryPrice),
        targetPrice: parseFloat(targetPrice),
        leverage: parseInt(leverageValue, 10),
      };
  
      const response = await fetch(`${BaseUrl}/api/orders/place`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      const result = await response.json();
  
      if (result?.entryOrder && result?.targetOrder) {
        toast.success("Order placed successfully!");
        fetchOpenPosition();
        setOrderQuantity("");
        setEntryPrice("");
        setTargetPrice("");
      } else {
        const errorMsg = result?.error?.msg || "Failed to place order.";
        toast.error(errorMsg);
      }
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("An error occurred while placing the order.");
    }
  };
  
    useEffect(() => {
      const token = sessionStorage.getItem("binance-token");
      if (!token) {
        navigate("/Login");
      }
    }, [navigate]);

  return (
    <div
    className="container-fluid app-container mt-4"
    style={{
      fontFamily: "'Roboto'",
      fontOpticalSizing: 'auto',
      fontWeight: 400,
      fontStyle: 'normal',
      fontVariationSettings: '"wdth" 100',
    }}
  >
  
  <div className="d-flex justify-content-between align-items-center mb-4">
  <h2 className="text-dark">Binance Perp</h2>
  <button className="btn btn-danger" onClick={handleLogout}>Logout</button>
</div>
      <div className="table-responsive">
        <table className="table table-striped text-center">
          <thead className="table-dark">
            <tr>
              <th>ETH Price</th>
              <th></th>
              <th>QTY</th>
              <th></th>
              <th>BTC Price</th>
              <th></th>
              <th>Total</th>
              <th>Leverage</th>
              <th>Order QTY</th>
              <th>Entry Price</th>
              <th>Target Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={prices.ETHUSDT >= 0 ? "text-success" : "text-danger"}>
                {prices.ETHUSDT || "Loading..."}
              </td>
              <td><span>x</span></td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter QTY"
                  value={quantity}
                  onChange={(e) => setQuantity(parseFloat(e.target.value) || 1)}
                />
              </td>
              <td><span>-</span></td>
              <td className={prices.BTCUSDT >= 0 ? "text-success" : "text-danger"}>
                {prices.BTCUSDT || "Loading..."}
              </td>
              <td><span>=</span></td>
              <td className={total >= 0 ? "text-success" : "text-danger"}>
              {!isNaN(total) && total !== null && total !== undefined ? total : 'N/A'}
              </td>
              <td>
                <input
                  type="range"
                  min="1"
                  max="10"
                  value={leverageValue}
                  onChange={(e) => setLeverageValue(e.target.value)}
                />
                <span className="ms-2 text-dark">{leverageValue}x</span>
              </td>
              <td>
              <input
                type="number"
                step="any"
                className="form-control"
                placeholder="Enter QTY"
                value={orderQuantity}
                onChange={(e) => setOrderQuantity(e.target.value)}
              />
            </td>

              <td>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Entry Price"
                  value={entryPrice}
                  onChange={(e) => setEntryPrice(parseFloat(e.target.value) || 1)}
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Target Price"
                  value={targetPrice}
                  onChange={(e) => setTargetPrice(parseFloat(e.target.value) || 1)}
                />
              </td>
              <td className="text-danger">
            <div className="d-flex align-items-center">
              <button
                className="btn btn-sm btn-success"
                onClick={handlePlaceOrder}
              >
                Buy
              </button>
            </div>
          </td>

            </tr>
          </tbody>
        </table>
      </div>

      {openPosition && (
  <div className="table-responsive mt-4">
     <h4 className="text-center text-dark mb-3">
       Open Position
    </h4>
    <table className="table table-bordered mb-0">
    <thead className="table-dark">
    <tr>
          <th>Position Amt</th>
          <th>Entry Price</th>
          <th>Mark Price</th>
          <th>Unrealized PnL</th>
          <th>Leverage</th>
          <th>Side</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{openPosition.positionAmt}</td>
          <td>{openPosition.entryPrice}</td>
          <td>{parseFloat(openPosition.markPrice).toFixed(2)}</td>
          <td>{parseFloat(openPosition.unrealizedProfit).toFixed(2)}</td>
          <td>{openPosition.leverage}x</td>
          <td>{openPosition.side}</td>
        </tr>
      </tbody>
    </table>
  </div>
)}

{openOrders.length > 0 && (
  <div className="mt-4">
    <h4 className="text-center text-dark mb-3">
       Open Orders
    </h4>
    <div className="table-responsive">
      <table className="table table-bordered text-center">
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>Order ID</th>
            <th>Side</th>
            <th>Qty</th>
            <th>Type</th>
            <th>Status</th>
            <th>Price</th>
            <th>Stop Price</th>
          </tr>
        </thead>
        <tbody>
          {openOrders.map((order, index) => (
            <tr key={order.orderId}>
              <td>{index + 1}</td>
              <td>{order.orderId}</td>
              <td>{order.side}</td>
              <td>{order.origQty}</td>
              <td>{order.type}</td>
              <td>{order.status}</td>
              <td>{order.price}</td>
              <td>{order.stopPrice}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

{orderHistory.length > 0 && (
        <div className="mt-5">
          <h4 className="text-center text-dark mb-3">
            <FaHistory className="me-2" /> Order History
          </h4>
          <div className="table-responsive">
            <table className="table table-bordered text-center">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Order ID</th>
                  <th>Symbol</th>
                  <th>Status</th>
                  <th>Price</th>
                  <th>Avg Price</th>
                  <th>Orig Qty</th>
                  <th>Executed Qty</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {orderHistory.map((order, index) => (
                  <tr key={order.orderId}>
                    <td>{index + 1}</td>
                    <td>{order.orderId}</td>
                    <td>{order.symbol}</td>
                    <td>{order.status}</td>
                    <td>{order.price}</td>
                    <td>{order.avgPrice}</td>
                    <td>{order.origQty}</td>
                    <td>{order.executedQty}</td>
                    <td>{new Date(order.updateTime || order.time).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
)}




    </div>
  );
};

export default BinanceSpread;
